export const getHeaderCounterText = (migrationEngagements, selectedItems) => {
  if (migrationEngagements) {
    return selectedItems.length > 0
      ? `(${selectedItems.length}/${migrationEngagements.length})`
      : `(${migrationEngagements.length})`;
  } else {
    return `(0)`;
  }
};
